module.exports = __webpack_public_path__ + "img/image4.81be2bf4.webp";